/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface EmailPromotion
 */
export interface EmailPromotion {
  /**
   *
   * @type {string}
   * @memberof EmailPromotion
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof EmailPromotion
   */
  provider: string;
  /**
   *
   * @type {string}
   * @memberof EmailPromotion
   */
  category: EmailPromotionCategoryEnum;
  /**
   *
   * @type {string}
   * @memberof EmailPromotion
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof EmailPromotion
   */
  benefit: string;
  /**
   *
   * @type {string}
   * @memberof EmailPromotion
   */
  terms: string;
  /**
   * Saved concise qualification and cost summary; absent or null uses full terms.
   * @type {string}
   * @memberof EmailPromotion
   */
  actionSummary?: string | null;
  /**
   *
   * @type {string}
   * @memberof EmailPromotion
   */
  enrollmentUrl: string | null;
  /**
   *
   * @type {string}
   * @memberof EmailPromotion
   */
  enrollmentDeadline: string | null;
  /**
   *
   * @type {string}
   * @memberof EmailPromotion
   */
  bookingDeadline: string | null;
  /**
   *
   * @type {string}
   * @memberof EmailPromotion
   */
  travelDeadline: string | null;
  /**
   *
   * @type {string}
   * @memberof EmailPromotion
   */
  expiresOn: string | null;
  /**
   *
   * @type {string}
   * @memberof EmailPromotion
   */
  sourceSubject: string;
  /**
   *
   * @type {Date}
   * @memberof EmailPromotion
   */
  sourceReceivedAt: Date;
  /**
   *
   * @type {string}
   * @memberof EmailPromotion
   */
  sourceSender: string;
  /**
   *
   * @type {string}
   * @memberof EmailPromotion
   */
  eligibilityNote: string | null;
  /**
   * Source-supported offer classification; absent means unknown.
   * @type {string}
   * @memberof EmailPromotion
   */
  offerType?: EmailPromotionOfferTypeEnum;
  /**
   * Ordinal usefulness score, not a reward valuation or eligibility guarantee.
   * @type {number}
   * @memberof EmailPromotion
   */
  relevanceScore?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof EmailPromotion
   */
  rankingReasons?: Array<string>;
}

/**
 * @export
 */
export const EmailPromotionCategoryEnum = {
  Airline: "airline",
  Hotel: "hotel",
  Car: "car",
  CreditCard: "credit_card",
  Other: "other",
} as const;
export type EmailPromotionCategoryEnum =
  (typeof EmailPromotionCategoryEnum)[keyof typeof EmailPromotionCategoryEnum];

/**
 * @export
 */
export const EmailPromotionOfferTypeEnum = {
  Signup: "signup",
  ExistingCard: "existing_card",
  General: "general",
  Unknown: "unknown",
} as const;
export type EmailPromotionOfferTypeEnum =
  (typeof EmailPromotionOfferTypeEnum)[keyof typeof EmailPromotionOfferTypeEnum];

/**
 * Check if a given object implements the EmailPromotion interface.
 */
export function instanceOfEmailPromotion(
  value: object
): value is EmailPromotion {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("provider" in value) || value["provider"] === undefined) return false;
  if (!("category" in value) || value["category"] === undefined) return false;
  if (!("title" in value) || value["title"] === undefined) return false;
  if (!("benefit" in value) || value["benefit"] === undefined) return false;
  if (!("terms" in value) || value["terms"] === undefined) return false;
  if (!("enrollmentUrl" in value) || value["enrollmentUrl"] === undefined)
    return false;
  if (
    !("enrollmentDeadline" in value) ||
    value["enrollmentDeadline"] === undefined
  )
    return false;
  if (!("bookingDeadline" in value) || value["bookingDeadline"] === undefined)
    return false;
  if (!("travelDeadline" in value) || value["travelDeadline"] === undefined)
    return false;
  if (!("expiresOn" in value) || value["expiresOn"] === undefined) return false;
  if (!("sourceSubject" in value) || value["sourceSubject"] === undefined)
    return false;
  if (!("sourceReceivedAt" in value) || value["sourceReceivedAt"] === undefined)
    return false;
  if (!("sourceSender" in value) || value["sourceSender"] === undefined)
    return false;
  if (!("eligibilityNote" in value) || value["eligibilityNote"] === undefined)
    return false;
  return true;
}

export function EmailPromotionFromJSON(json: any): EmailPromotion {
  return EmailPromotionFromJSONTyped(json, false);
}

export function EmailPromotionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): EmailPromotion {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    provider: json["provider"],
    category: json["category"],
    title: json["title"],
    benefit: json["benefit"],
    terms: json["terms"],
    actionSummary:
      json["action_summary"] == null ? undefined : json["action_summary"],
    enrollmentUrl: json["enrollment_url"],
    enrollmentDeadline: json["enrollment_deadline"],
    bookingDeadline: json["booking_deadline"],
    travelDeadline: json["travel_deadline"],
    expiresOn: json["expires_on"],
    sourceSubject: json["source_subject"],
    sourceReceivedAt: new Date(json["source_received_at"]),
    sourceSender: json["source_sender"],
    eligibilityNote: json["eligibility_note"],
    offerType: json["offer_type"] == null ? undefined : json["offer_type"],
    relevanceScore:
      json["relevance_score"] == null ? undefined : json["relevance_score"],
    rankingReasons:
      json["ranking_reasons"] == null ? undefined : json["ranking_reasons"],
  };
}

export function EmailPromotionToJSON(json: any): EmailPromotion {
  return EmailPromotionToJSONTyped(json, false);
}

export function EmailPromotionToJSONTyped(
  value?: EmailPromotion | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    provider: value["provider"],
    category: value["category"],
    title: value["title"],
    benefit: value["benefit"],
    terms: value["terms"],
    action_summary: value["actionSummary"],
    enrollment_url: value["enrollmentUrl"],
    enrollment_deadline: value["enrollmentDeadline"],
    booking_deadline: value["bookingDeadline"],
    travel_deadline: value["travelDeadline"],
    expires_on: value["expiresOn"],
    source_subject: value["sourceSubject"],
    source_received_at: value["sourceReceivedAt"].toISOString(),
    source_sender: value["sourceSender"],
    eligibility_note: value["eligibilityNote"],
    offer_type: value["offerType"],
    relevance_score: value["relevanceScore"],
    ranking_reasons: value["rankingReasons"],
  };
}
